import { createFileRoute } from '@tanstack/react-router'
import { PowerCustomerUploadRoutePage } from 'pages/documents/PowerCustomerUploadRoutePage'
import {
  SEARCH_PARAM_ORG_ID,
  SEARCH_PARAM_SITE_ID,
} from 'routes/(global_search_params)/-searchParams'
import { z } from 'zod'

const powerCustomerUploadSearchParamsSchema = z.object({
  [SEARCH_PARAM_ORG_ID]: z.string().optional(),
  [SEARCH_PARAM_SITE_ID]: z.string().optional(),
})

function RouteComponent() {
  const search = Route.useSearch()
  return (
    <PowerCustomerUploadRoutePage searchSiteId={search[SEARCH_PARAM_SITE_ID]} />
  )
}

export const Route = createFileRoute('/documents/upload')({
  component: RouteComponent,
  validateSearch: powerCustomerUploadSearchParamsSchema,
  staticData: {
    title: 'Document Upload',
    layout: {
      enableScrolling: false,
      enforceMaxWidth: false,
    },
  },
})
